const config = {
  domainName: process.env.REACT_APP_DOMAIN_NAME,
  frontendUrl: process.env.REACT_APP_FRONTEND_URL,
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  comparisionSite: process.env.REACT_APP_COMPARISION_SITE_URL,
  companyLogoPath: process.env.REACT_APP_COMPANY_LOGOS_PATH,
  googleAnalyticsKey: process.env.REACT_APP_GOOGLE_ANALYTICS_KEY,
  socketUrl: process.env.REACT_APP_SOCKET_URL,
  defaultDateFormat: 'MM-DD-YYYY',
  defaultComparisonDateFormat: '%m-%d-%Y',
  indexDbDatabaseName: 'companiesDataDb',
  indexDbDomesticTableName: 'domestic',
  indexDbGlobalTableName: 'global',
  indexDbSocialScreenerTableName: 'social-screener',
  maintenanceByPassKey: 'multidimensional-hash',
  sentryDSN: process.env.REACT_APP_SENTRY_DSN,
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  youtubePlaylistId: process.env.REACT_APP_YOUTUBE_PLAYLIST_ID,
  homepageWidgetApiKey: '81e60c88dfe0a0aabac0e132ded2bbb5fe4401a6',
  socialSentimentGridLayoutKey: 'socialSentimentGridLayoutKey',
  homepageGridLayoutKey: 'homepageGridLayoutKey',
};
export default config;
